module.exports = __webpack_public_path__ + "df296aaf33aaa92479883c71bfe2604a.png";